import Honorarios from "../../view/components/RegistroUsuarios/Honorarios/VistaHonorarios";
import withVistaHonorarios from "../../hoc/Docentes/withVistaHonorarios";

export default withVistaHonorarios(Honorarios);